import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ApiService } from '../../service/api_service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { FirstLastCallDataModel } from '../../model';
import { HttpClient } from '@angular/common/http';
import * as $ from 'jquery';
import { Subscription } from 'rxjs'; 
@Component({
    selector: 'app-firstlastcall',
    template: require('./firstlastcall.component.html'),
    styles: []
})
export class FirstLastComponent implements OnInit {
    formgroup: FormGroup;
    FirstLastCall: any;
    private columnDefs;
    private rowHeight;
    api: any;
    busy: Subscription;
    columnApi: any;
    defaultColDefine;
    private gridColumnApi;
    private detailCellRendererParams;
    currentMonth: any;
    staffTypes: any;
    staff: any;
    FirstLastCallDetails :any ;
    designation: any;
    currentDate: any;
    firstDate: string;
    lastDate: string;
    ManagerList: any = [];
    empName: any = []; 
    token:any;
    @ViewChild('close') public modal: ElementRef;
    FirstLastCallDataModel: FirstLastCallDataModel = new FirstLastCallDataModel();

    static parameters = [ApiService, HttpClient];
    constructor(private apiService: ApiService, private http: HttpClient) {
        this.columnDefs = [
            // { headerName: 'S.No.', valueGetter: "node.rowIndex + 1", width: 80 },
            { headerName: 'DCR Date', field: "PlanDate" },
            // { headerName: 'Employee', field: "Client_LegalName", pinned: 'left' },
            { headerName: 'Employee', field: "Client_Name" },
            { headerName: 'Emp code', field: "Client_Code" },
            { headerName: 'Manager', field: "Manager" },
            { headerName: 'Head Qtr', field: "HQName" },
            { headerName: 'Designation', field: "Designation"},
            { headerName: 'Work With', field: "WorkingWith" },
            { headerName: 'Route', field: "RouteName" },
            { headerName: 'DA Type', field: "DAType", suppressFilter: true },
            { headerName: 'First Call', field: "FirstCall" },
            { headerName: 'Last Call', field: "LastCall" },
            { headerName: 'WH', field: "WH" },
          
        ];


        this.rowHeight = 50;
        this.defaultColDefine = { resizable: true };
      
    }

  

    ngOnInit() {
        this.token = JSON.parse(sessionStorage.getItem("currentUser"));
        var date = new Date();
        var year = date.getFullYear();
        var month = (date.getMonth() + 1).toString().padStart(2, "0");
        this.firstDate = year + '-' + month + '-' + date.getDate().toString().padStart(2, "0");
        this.lastDate = year + '-' + month + '-' + date.getDate().toString().padStart(2, "0");
        console.log('firstDate ', this.firstDate, this.lastDate);
        this.FirstLastCall_Form.controls['fromDate'].setValue(
            this.firstDate
        );
        this.FirstLastCall_Form.controls['toDate'].setValue(
            this.lastDate
        );

        this.FirstLastCallDataModel.ManagerID = '0';
        this.FirstLastCallDataModel.employeeCode = "0";
        this.FirstLastCallDataModel.stafftype = "0";
        this.formgroup = this.FirstLastCall_Form;
        this.getManagerDetails();
        this.getEmployee();
        this.getStaffTypes();
        $('#filter-option').trigger('click');
    }

    FirstLastCall_Form = new FormGroup({
        fromDate: new FormControl('', [Validators.required]),
        toDate: new FormControl('', [Validators.required]),
        employee: new FormControl('', [Validators.required]),
        ManagerID: new FormControl('', [Validators.required]),
        staffType: new FormControl('', [Validators.required]),
    });

    onGridReady = (params) => {
        this.api = params.api;
        this.gridColumnApi = params.columnApi;
        this.api.hideOverlay();
    }

  

    getManagerDetails() {
        var data = {
            Id: this.token.id
        };
        this.http.post('/api/Report/getManagerListForLogUnLog',data)
            .subscribe(res => {
                this.ManagerList = res;
            });
    }

    getEmployee() {
        var data = {
            Id: this.token.id
        };
    this.apiService.getEmpDetails(data).subscribe((res: any) => {
            this.empName = res.data;
        })
    }

    onBtnExport() {
        this.api.exportDataAsCsv({ fileName: 'DayWiseCallDetails' });
    }

    onFilterTextBoxChanged() {
        this.api.setQuickFilter(document.querySelector<HTMLInputElement>('#filter-text-box')!.value);
        this.api.refreshCells();
    }

    getStaffTypes() {
        this.apiService.getStaffTypes().subscribe((res: any) => {
            this.staffTypes = res.data;
        });
    }

    filterData() {
        this.FirstLastCallDataModel.fromDate = this.formgroup.value.fromDate;
        this.FirstLastCallDataModel.toDate = this.formgroup.value.toDate;
        this.FirstLastCallDataModel.LoginId=this.token.id;
       // console.log(this.FirstLastCallDataModel);
       this.busy = this.apiService.getFirstLastCallDetail(this.FirstLastCallDataModel).subscribe((res: any) => {
            console.log("response",res);
           this.FirstLastCallDetails = res;
        })

    }
}
